import { compose, prop } from 'ramda';
import { branch, renderComponent } from 'recompose';

import connect from 'app/libs/connect';
import { isUserAuthenticated } from 'app/features/user/selectors';
import CreateAccountButton from 'app/features/newLanding/components/newProductComparison/Product/Buttons/CreateAccountButton';
import ExploreButton from 'app/features/newLanding/components/newProductComparison/Product/Buttons/ExploreButton';

const FreeProductButton = compose(
  connect({ isUserAuthenticated }),
  branch(prop('isUserAuthenticated'), renderComponent(ExploreButton)),
)(CreateAccountButton);

export default FreeProductButton;
